import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

type RequestCancellationInput = {
  lotteryId?: string;
  roomId?: string;
  cancellationReason: string;
};

type RequestCancellationResult = {
  success: boolean;
  lotteryId: string;
  roomId: string;
  roomNumber: string;
};

type ReviewCancellationInput = {
  lotteryId: string;
  action: 'approve' | 'reject';
  reviewMemo?: string;
};

type ReviewCancellationResult = {
  success: boolean;
  action: 'approve' | 'reject';
  roomId: string;
  roomNumber: string;
  residentUid?: string;
};

type CancelLotteryInput = {
  lotteryId: string;
  attachment?: {
    name: string;
    storagePath: string;
    size: number;
    contentType: string;
  };
};

type CancelLotteryResult = {
  success: boolean;
  lotteryId: string;
  roomId: string;
  roomNumber: string;
  residentUid?: string;
};

export const requestPortvilleContractCancellation = async (
  input: RequestCancellationInput
): Promise<RequestCancellationResult> => {
  const callable = httpsCallable<RequestCancellationInput, RequestCancellationResult>(
    functions,
    'requestPortvilleContractCancellation'
  );
  const result = await callable(input);
  return result.data;
};

export const reviewPortvilleContractCancellation = async (
  input: ReviewCancellationInput
): Promise<ReviewCancellationResult> => {
  const callable = httpsCallable<ReviewCancellationInput, ReviewCancellationResult>(
    functions,
    'reviewPortvilleContractCancellation'
  );
  const result = await callable(input);
  return result.data;
};

export const cancelPortvilleLottery = async (
  input: CancelLotteryInput
): Promise<CancelLotteryResult> => {
  const callable = httpsCallable<CancelLotteryInput, CancelLotteryResult>(
    functions,
    'cancelPortvilleLottery'
  );
  const result = await callable(input);
  return result.data;
};
